import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryNavProps {
  active?: string;
}

export default function CategoryNav({ active }: CategoryNavProps) {
  return (
    <section className="w-full bg-background-50 border-b border-background-200/70">
      <div className="w-full px-4 md:px-6 py-4">
        <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide pb-1">
          <Link
            to="/"
            className={`shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
              !active
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            全部
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1.5 ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-xs`}></i>
              </div>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}